import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/produto.msg'

class EntradasService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('entradas', msg)
  }
}

export default new EntradasService()
